import logo from './logo.jpg';
import './App.css';
import ReactTerminal from 'react-terminal-component';

import {
  EmulatorState,
  OutputFactory,
  // CommandMapping,
  // EnvironmentVariables,
  FileSystem,
  // History,
  Outputs,
  // defaultCommandMapping
} from 'javascript-terminal';

const theme = {
  fontSize: '1.3rem',
  spacing: '1%',
  fontFamily: 'Comic Mono',
  height: '50vh',
  width: '100%',
  background: '#391b24',
  commandColor: '#dc243a',
  outputColor: '#840498',
  errorOutputColor: '#ffa1a1',
  promptSymbolColor: '#dc243a'
};

const customState = EmulatorState.create({
  'fs': FileSystem.create({
    '/home': {},
    '/home/README': { content: 'This is a text file' },
    '/home/nested/directory': {},
    '/home/nested/directory/file': { content: 'End of nested directory!' }
  })
});

const App = () => {
  const defaultOutputs = customState.getOutputs();
  const outputArray = [
    "welcome stranger, to alleycatboy's place.",
    "you can't return home.",
    ":3c",
  ];

  const newOutputs = Outputs.addRecord(
    defaultOutputs, OutputFactory.makeTextOutput(outputArray.join('\n'))
  );
  const emulatorState = customState.setOutputs(newOutputs);

  return (
    <>
      <ReactTerminal
        promptSymbol="[alleycatboy@neocities]~>"
        className="terminal"
        clickToFocus
        emulatorState={emulatorState}
        theme={theme}
      />
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <p>
            we've only just started falling into the <code>public static void</code>
          </p>
          <a
            className="App-link"
            href="https://alleycatboy.tumblr.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Look into the AlleyCatBoy
          </a>
        </header>
      </div>
    </>
  );
}

export default App;
